<template>
  <div>
    <div class="container fr-aic fr-jcsb">
      <comp-tab :data="[{ label: '生效中', value: 1 }, { label: '已删除', value: 2 }]" v-model="params.isdeleted" />
      <el-button @click="showNewRuleForm = true" size="mini" type="primary">新建储值规则</el-button>
    </div>
    <div class="container">
      <el-table :data="list">
        <el-table-column label="ID" prop="id"></el-table-column>
        <el-table-column label="储值金额">
          <template slot-scope="scope">
            <span>{{ scope.row.amount / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="赠送金额">
          <template slot-scope="scope">
            <span>{{ scope.row.gift / 100 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.createdat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="删除时间" v-if="params.isdeleted == 2">
          <template slot-scope="scope">
            <span>{{ new Date(scope.row.deletedat * 1000).toLocaleString() }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" v-if="params.isdeleted == 1">
          <template slot-scope="scope">
            <el-button @click="onClickDel(scope.row)" size="small" type="text">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="table-bottom">
      <el-button v-if="hasMore" :loading="loadmore" @click="getList" size="small" type="primary">加载更多</el-button>
      <span style="color: #ccc; font-size: 12px;" v-else>已加载全部，没有更多了</span>
    </div>
    <!--  编辑分类弹框 -->
    <el-dialog :visible.sync="showNewRuleForm" title="新建储值规则" width="500px">
      <el-form label-width="50px" ref="form" label-position="left" size="small">
        <el-form-item label="储值">
          <el-row>
            <el-col span="8">
              <el-input placeholder="请输入充值金额" v-model="newRuleForm.amount"></el-input>
            </el-col>
            <el-col span="3" style="text-align: center;">送</el-col>
            <el-col span="8">
              <el-input placeholder="请输入赠送金额" v-model="newRuleForm.gift"></el-input>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div class="dialog-footer fr-jcfs" slot="footer">
        <el-button @click="onSubmit" size="small" type="primary">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../../components/tab/index.vue';
import { M } from '../../../service/grpc.js';
import { rpc } from '../../../service/index.js';
import { getToken } from '../../../service/helper.js';

export default {
  components: {
    'comp-tab': Tab
  },
  data() {
    return {
      params: {
        count: 20,
        idlessthan: 0,
        isdeleted: 1,
        sortby: 1,
        sort1: 1
      },
      list: [],
      loadmore: false,
      hasMore: true,
      newRuleForm: {
        amount: 0,
        gift: 0
      },
      showNewRuleForm: false,
      token: ''
    };
  },
  watch: {
    'params.isdeleted': function() {
      this.list = [];
      this.getList();
    }
  },
  created() {
    this.token = getToken();
    this.getList();
  },
  methods: {
    async getList() {
      this.loadmore = true;
      const { scrollY } = window;
      this.params.idlessthan = this.list.length ? this.list[this.list.length - 1].id : 0;
      const res = await rpc(
        'StoreRechargeService.GetRechargeList',
        M('RechargeListQueryRequest', {
          token: M('Token', { token: this.token }),
          ...this.params
        })
      );
      this.list = this.list.concat(res.rechargelistList);
      this.hasMore = res.rechargelistList.length;
      if (this.params.idlessthan !== 0) {
        window.scroll(0, scrollY);
      }
      this.loadmore = false;
    },

    onClickDel(rule) {
      const row = JSON.parse(JSON.stringify(rule));
      row.deletedat = parseInt(Date.now() / 1000);
      rpc(
        'StoreRechargeService.UpdateRecharge',
        M('RechargeWithTokenRequest', {
          token: M('Token', { token: this.token }),
          recharge: M('Recharge', row)
        })
      ).then(res => {
        this.list.splice(this.list.findIndex(v => v.id === res.id), 1);
        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    },

    onSubmit() {
      const row = JSON.parse(JSON.stringify(this.newRuleForm));
      row.amount *= 100;
      row.gift *= 100;

      rpc(
        'StoreRechargeService.CreateRecharge',
        M('RechargeWithTokenRequest', {
          token: M('Token', { token: this.token }),
          recharge: M('Recharge', row)
        })
      ).then(res => {
        if (this.params.isdeleted == 1) {
          this.list.splice(0, 0, res);
        }

        this.showNewRuleForm = false;
        this.newRuleForm = {
          amount: 0,
          gift: 0
        };

        this.$message({
          message: '操作成功',
          type: 'success'
        });
      });
    }
  }
};
</script>

<style></style>
